import React,{useEffect,useContext, useRef, useState} from 'react';
import { NavLink, Link, useLoaderData, useLocation} from "react-router-dom";
import ProgressiveImage from './ProgressiveImage/BackgroundImage';
import ProgressiveImageImg from './ProgressiveImage/FirstSlider';
import { ThemeContext } from '../context/ThemeContext';
import { useSwiper, Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Pagination, Navigation, Autoplay } from 'swiper/modules';
import ColoredScrollbars from './ColoredScrollbars';
import { useHashScroll } from '../hooks/useHashScroll';

//import MinimalScrollTop from './MinimalScrollTop';
import 'swiper/css';
import 'swiper/css/virtual';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';



function Home(props) {

  const [swiperRef, setSwiperRef] = useState(null);
  const [imgHeight, setImgHeight] = useState(100);
  const [currentHash, setCurrentHash] = useState('');
  const scrollRef_1 = useRef(null);
  const scrollRef_2 = useRef(null);



  //console.log(props);
  let projectsData = useLoaderData();
  let projectsCineFeat = projectsData.items['cineFeat'];
  let projectsCine = projectsData.items['cine'];
   let projectsInProd = projectsData.items['inprod'];
  let projectsTv = projectsData.items['tv'];
  let projectsDoc = projectsData.items['doc'];
  let news = projectsData.items['news'];
  //console.log(projectsData.items);
  const theme = useContext(ThemeContext);
//console.log(theme.state.vertical);

const location = useLocation();

useEffect(() => {
if (location.hash) {
  setTimeout(() => {
    const element = document.querySelector(location.hash);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, 100); // small delay to allow DOM render
}
}, [location]);

useEffect(()=> {

  if(theme.state.vertical && imgHeight != 50 ){
  setImgHeight(50)
  //console.log('switching vert.')
  }
},[theme.state.vertical])


  return (
<section className={"pt-0 " + props.transition}>

<Swiper
      onSwiper={setSwiperRef}
      className="mySwiper"

      modules={[Pagination, Navigation, EffectFade, Autoplay]}
      spaceBetween={0}
      centeredSlides={true}
      speed={800}
        autoplay={{
          delay: 4000,
          disableOnInteraction: true,
        }}
        //waitForTransition
        pagination={{
          clickable: true,
        }}
      loop={true}
      slidesPerView={1}
      effect={'fade'}
      navigation={true}
      onSlideChange={(swiper) => {
      // Hide all logos
      swiper.el.querySelectorAll('.project-logo').forEach((logo) => {
        logo.classList.remove('opacity-100', 'pl-6');
        logo.classList.add('opacity-0', 'pl-0');
      });

      // Reveal the active one
      const activeSlideEl = swiper.slides[swiper.activeIndex];
      const activeLogo = activeSlideEl.querySelector('.project-logo');

      if (activeLogo) {
        // Force reflow to restart animation if needed
        void activeLogo.offsetWidth;

        activeLogo.classList.remove('opacity-0', 'pl-6');
        activeLogo.classList.add('opacity-100', 'pl-6');
      }
    }}


      //onSwiper={(swiper) => console.log(swiper.activeIndex)}
    >
      {projectsCineFeat.length > 0 ? projectsCineFeat.map((project,index) => (
      index < 16 ?

      <SwiperSlide key={'cine-'+ index}>
        
        <div style={{}} className="w-full flex flex-col items-center p-0 space-y-3 text-center">
        <NavLink className="overflow-hidden relative" aria-label={'ver el proyecto ' + project.name} to={'../' + project.tax[0].slug + '/'+project.slug} state={{ from: 'home', backLink:'cine' }}>

        <picture style={{overflow:'hidden'}} id={'btn-' + index} className="link">
        <ProgressiveImage
        src={project.image_bg_thumb.url}
        placeholder={'/img/trans.gif'}
        modal={theme.modal}
        bg={'#333'}
        imgMargin={0}
        imgWidth={100}
        imgHeight={imgHeight}
        backgroundPosition={'center center'}
        />
        </picture>

      {/* <div className="flex flex-col items-center space-y-1 text-center bg-magenta  dark:bg-magenta">

            <p>{project.tax[0].name}</p>
            <h3 className="text-gl notranslate font-light text-white uppercase pb-6">{project.name}</h3>

        </div>
        */}
        { project.image_logo ?
        <div style={{transform: 'translateZ(0)', transition: 'padding 1s ease, opacity 0.8s ease'}} className={"fadeIn absolute bottom-12 md:bottom-18 left-0 md:left-2 text-white opacity-0 pl-6 transform transition-all duration-500 delay-200 ease-out project-logo project-logo-" + index }><img className="w-[200px] md:w-[480px]" src={project.image_logo} alt="item.logo"/></div>
        : '' }
      </NavLink>
        </div>
    </SwiperSlide>

       : ''     ))  : ''}
     </Swiper>

  {/*   <button onClick={() => swiperRef.slideNext()}>Slide to the next slide</button>
     <button onClick={() => swiperRef.slidePrev()}>Slide to the prev slide</button>
     */}

  {/*
    <div className="text-center p-4 mb-4 space-x-0 md:space-x-2 md:mb-8">
         <NavLink to="./cine" className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-magenta rounded-xl sm:w-auto sm:mb-0">
             Ver m&aacute;s CINE
             <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
           </NavLink>
     </div>
     */}








       {/* <div className="text-center p-4 mb-4 space-x-0 md:space-x-2 md:mb-8">
           <NavLink to="./documentales" className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-lg text-white bg-magenta rounded-xl sm:w-auto sm:mb-0">
               Ver m&aacute;s DOCUMENTALES
               <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
             </NavLink>
       </div> */}


       <div className="w-full p-8 bg-[#c00] center text-center">
          <Link to="/theclub" className="w-full block w-full">
            <h3 className="font-semibold w-full block text-3xl text-white w-full">ÚNETE AL CLUB AF</h3>
          <p className="font-regular w-full block text-xl text-white w-full max-w-[500px] mx-auto">
            Súmate a nuestra comunidad para recibir invitaciones a nuestros preestrenos, pases tests, sorteos </p>
            <p className="font-semibold text-xl">
              ¡y mucho más!
          </p>
        </Link>
        </div>

       {/* CINEMA */}
       <div className="pl-3 md:pl-10">
         <div id="cinema" className="grid grid-cols-2 gap-1 py-4 pt-8">
           <div className="flex items-end justify-start">
             <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 text-gray-900 pb-1">
               <NavLink to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>
               CINE
             </NavLink>
             </h2>
         </div>
           <div className="text-gray-900 flex items-end justify-end">
             <NavLink style={{paddingBottom:9+'px'}} to="./cine" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
                 + Cine
                 {/*<svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>*/}
               </NavLink>
         </div>
         </div>
       {/*
         <div id="cinema" className="w-full">
       <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 py-12 pb-4 text-gray-800">Cinema</h2>
       </div> */}

       <div className="w-full py-0 bg-white center relative">
               <div className="overflow-x-auto whitespace-nowrap py-2">
                 <ColoredScrollbars className="scrollLightBg cineScroll" style={{ height: 520 }}>
                 {projectsCine.length > 0 ? projectsCine.map((project,index) => (
                 index < 20 ?

                 <div className={'grow inline-block w-[280px] text-gray-800  mx-1 items-center justify-center text-md font-medium grow-cine-' + index} key={'doc-'+ index}>

                     <NavLink className="w-full" to={'../cine/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

                     <picture id={'btn-cine-' + index} className="link">
                     <ProgressiveImageImg
                     src={project.image_thumb.url}
                     placeholder={'/static/trans.gif'}
                     modal={theme.modal}
                     bg={'#333'}
                     imgMargin={props.imgMargin}
                     />
                     </picture>

                     <div className="flex flex-col p-1 space-y-1 text-left text-gray-800">
                         <p style={{fontSize:110+'%'}} className="notranslate font-medium pb-2 pt-3 text-wrap">{project.name}</p>
                     </div>

                   </NavLink>

                 </div>

                  : ''     ))  : ''}
              </ColoredScrollbars>
               </div>
              {/* <div className="text-center px-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-gray-900">
                 <NavLink to="./cine"state={{ from: 'home', backLink:'cine' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
                     Ver m&aacute;s Cine
                     <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                   </NavLink>
               </div> */}
               <button className="ml-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.cineScroll .view');
                if (view) {
                    view.scrollBy({ left: -_w, behavior: 'smooth' });
                }
               }
             } className="button-prev text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                 </svg>
               </button>

               <button className="mr-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.cineScroll .view');
                if (view) {
                    view.scrollBy({ left: _w, behavior: 'smooth' });
                }
               }
             } className="button-next text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                 </svg>
               </button>
       </div>
</div>


       {/* IN PROD */}
       <div className="pl-3 md:pl-10">
         <div id="in-produccion" className="grid grid-cols-1 gap-1 py-4 pt-8">
           <div className="flex items-end justify-start">
             <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 text-gray-900 pb-1">
               EN PRODUCCIÓN
             </h2>
         </div>

         </div>


       <div className="w-full py-0 bg-white center relative">
               <div className="overflow-x-auto whitespace-nowrap py-2">
                 <ColoredScrollbars className="scrollLightBg" style={{ height: 520 }}>
                 {projectsInProd.length > 0 ? projectsInProd.map((project,index) => (
                 index < 20 ?

                 <div className={'grow inline-block w-[280px] text-gray-800  mx-1 items-center justify-center text-md font-medium grow-cine-' + index} key={'doc-'+ index}>

                     <NavLink className="w-full" to={'../in-produccion/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'cine' }}>

                     <picture id={'btn-cine-' + index} className="link">
                     <ProgressiveImageImg
                     src={project.image_thumb.url}
                     placeholder={'/static/trans.gif'}
                     modal={theme.modal}
                     bg={'#333'}
                     imgMargin={props.imgMargin}
                     />
                     </picture>

                     <div className="flex flex-col p-1 space-y-1 text-left text-gray-800">
                         <p style={{fontSize:110+'%'}} className="notranslate font-medium pb-2 pt-3 text-wrap">{project.name}</p>
                     </div>

                   </NavLink>

                 </div>

                  : ''     ))  : ''}
              </ColoredScrollbars>
               </div>
              {/* <div className="text-center px-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-gray-900">
                 <NavLink to="./cine"state={{ from: 'home', backLink:'cine' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
                     Ver m&aacute;s Cine
                     <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                   </NavLink>
               </div> */}
               <button className="ml-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.inProdScroll .view');
                if (view) {
                    view.scrollBy({ left: -_w, behavior: 'smooth' });
                }
               }
             } className="button-prev text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                 </svg>
               </button>

               <button className="mr-2 top-[50%]" onClick={() => {
                 const el = document.querySelector('.grow-cine-0');
                 const _w = el?.getBoundingClientRect().width + 8;


                 const view = document.querySelector('.inProdScroll .view');
                if (view) {
                    view.scrollBy({ left: _w, behavior: 'smooth' });
                }
               }
             } className="button-next text-white">
                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
                   <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                 </svg>
               </button>
       </div>
</div>


{/* TELEVISION */}
<div className="pl-3 md:pl-10 bg-gray-900">
{/*<div id="tv" className="w-full">
<h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 py-8 text-white">Series</h2>
</div>*/}

<div id="tv" className="grid grid-cols-2 gap-1 py-4 pt-8">
  <div className="flex items-end justify-start">
    <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 text-white pb-1">
      <NavLink to="./tv" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'tv' }}>
      SERIES
    </NavLink>
    </h2>
</div>
  <div className="text-white flex items-end justify-end">
    <NavLink style={{paddingBottom:9+'px'}} to="./tv" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'tv' }} className="inline-flex pr-4 mr-1 md:pr-12 items-center">
        + Series
      </NavLink>
</div>
</div>

<div className=" w-full py-0  center relative">
        <div className="overflow-x-auto whitespace-nowrap scrollbar-hide py-2 h-[350px] md:h-[390px]">
          <ColoredScrollbars id="-2" className="scrollDarkBg">
          {projectsTv.length > 0 ? projectsTv.map((project,index) => (
          index < 100 ?

          <div className={'grow inline-block w-80 md:w-100 text-gray-800  mx-1.5 items-center justify-center text-md font-medium grow-tv-' +index} key={'doc-'+ index}>

              <NavLink className="w-full" to={'../tv/'+project.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'tv' }}>

              <picture id={'btn-tv-' + index} className="link">
              <ProgressiveImageImg
              src={project.image_bg_thumb.url}
              placeholder={'/static/trans.gif'}
              modal={theme.modal}
              bg={'#333'}
              imgMargin={props.imgMargin}
              />
              </picture>

              <div className="flex flex-col p-1 space-y-1 text-left">
                  <p style={{fontSize:110+'%'}} className="notranslate font-medium text-white pb-0 pt-3 text-wrap">{project.name}</p>
              </div>

            </NavLink>

          </div>

           : ''     ))  : ''}
       </ColoredScrollbars>
        </div>
      {/*  <div className="text-center p-4 mb-4 space-x-0 md:space-x-2 md:mb-8">
          <NavLink to="./tv"state={{ from: 'home', backLink:'tv' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md colorChange text-white  sm:w-auto sm:mb-0 pt-4">
              Ver m&aacute;s TV
              <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
            </NavLink>
        </div> */}
        <button className="ml-2 button-prev button-prev-tv text-white" onClick={() => {
          const el = document.querySelector('.grow-tv-0');
          const _w = el?.getBoundingClientRect().width + 8;


          const view = document.querySelector('.scrollDarkBg .view');
         if (view) {
             view.scrollBy({ left: -_w, behavior: 'smooth' });
         }
        }
      } >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
        </button>

        <button className="mr-2 -mt-2 button-next button-next-tv text-white" onClick={() => {
          const el = document.querySelector('.grow-tv-0');
          const _w = el?.getBoundingClientRect().width + 8;


          const view = document.querySelector('.scrollDarkBg .view');
         if (view) {
             view.scrollBy({ left: _w, behavior: 'smooth' });
         }
        }
      }>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.3" stroke="currentColor" className="size-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
          </svg>
        </button>

</div>
</div>

{/* News */}



<div className="pl-3 md:pl-10">
{/* <div id="news" className="grid w-full grid-cols-2 gap-0">
<h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 py-4 pt-24 text-gray-800">Noticias</h2>
</div> */}

<div id="news" className="grid grid-cols-2 gap-1 py-4 pt-8">
  <div className="text-gray-900 flex items-end justify-start">
    <h2 style={{fontSize:'2em'}} className="text-8xl font-medium text-left px-2.5 text-gray-800 pb-1">
      <NavLink to="./noticias" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'noticias' }} className="inline-flex pr-2 md:pr-10 items-center">
      NOTICIAS
    </NavLink>
    </h2>
</div>
  <div className="text-gray-900 flex items-end justify-end">
    <NavLink style={{paddingBottom:9+'px'}} to="./noticias" onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'noticias' }} className="inline-flex pr-4 mr-1 md:pr-14 items-center">
        + Noticias
      </NavLink>
</div>
</div>
<div style={{borderBottom: '1px solid #000'}} className="w-[95.5%] h-1 mb-4"/>


<div className=" w-full py-8 bg-white">
        <div className="">

  {news.length > 0 ? news.map((news,index) => (

  index < 100 ?

  <div className="w-full text-gray-800 px-2 mb-2 flex text-md font-medium" key={'doc-'+ index}>
    <div className="p-6 md:pl-32 text-left">
      {news.url ?
    <a className="overflow-hidden mb-10" target="_blank" href={news.url} state={{ from: 'home', backLink:'noticias' }}>
    <div className="flex flex-col items-center pb-6 space-y-1 text-left">
      <p className="roboto-slab-ttl notranslate font-medium pb-2 text-wrap text-xl md:text-2xl">
        <span className="inline-block"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="px-auto size-6 inline mr-4 -mt-2">
      <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
      </svg> </span>{news.title}

          <br/>

          <span className="newsLine inline-block mr-4"></span><small className="mt-4 font-light">{new Date(news.date).toLocaleDateString()}</small>
      </p>
    </div>

  </a> :

  <NavLink className="overflow-hidden mb-18" to={'../noticias/'+news.slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }} state={{ from: 'home', backLink:'noticias' }}>
  <div className="flex flex-col items-center pb-6 space-y-1 text-left">
      <p className="roboto-slab-ttl notranslate font-medium pb-2 text-wrap text-xl md:text-2xl">{news.title}<br/>
          <span className="newsLine inline-block mr-4"></span><small className="mt-4 font-light">{new Date(news.date).toLocaleDateString()}</small>
    </p>
  </div>

</NavLink>

}
    </div>
  </div>

   : ''     ))  : ''}

</div>
{/*<div className="text-center p-4 mb-4 space-x-0 md:space-x-2 md:mb-8 text-gray-900">
  <NavLink to="./noticias"state={{ from: 'home', backLink:'noticias' }} className="inline-flex items-center justify-center w-full px-6 py-3 mb-2 text-md  sm:w-auto sm:mb-0 pt-2">
      Ver m&aacute;s Noticias
      <svg className="w-4 h-4 ml-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
    </NavLink>
</div>*/}
</div>
</div>
</section>

  )
}

export default Home
